import  {Component} from 'react';
import {connect} from 'react-redux';

import Aux from '../../hoc/hocAux';
import classes from './ActivitiesStyle.module.css';
import {fetchAllActivites} from '../../actions/ActivitiesAction';

class Activities extends Component {
    state = {
        startDate: "",
        endDate: "",
      };

    UNSAFE_componentWillMount() {
        const params = new URLSearchParams(window.location.search);
        const start  = params.get("start");
        const end    = params.get("end");
        if (start && end) {
            this.setState({ startDate: start, endDate: end }, () =>
              this.props.fetchAllActivites(start, end)
            );
          } else {
            this.props.fetchAllActivites(); // fetch everything
          }
        
        // this.props.fetchAllActivites();
    }
    handleChange = (key) => (e) => this.setState({ [key]: e.target.value });

    handleSearch = () => {
        const { startDate, endDate } = this.state;
        console.log("startDAte",startDate);
        
        if (startDate && endDate) {
          this.props.fetchAllActivites(startDate, endDate);
          // (optional) push to URL so it can be shared/bookmarked
          const qs = `?start=${startDate}&end=${endDate}`;
          window.history.replaceState(null, "", qs);
        } else {
          this.props.fetchAllActivites(); // fallback to all
          window.history.replaceState(null, "", window.location.pathname);
        }
      };

    checkString = (match, value) => {
        switch (match) {
            case 'loginTime':
                return `Logged in at: ${new Date(value)}\n`;
            case 'logoutTime':
                return `Logged out at: ${new Date(value)}\n`;
            case 'acceptingChatOnTime':
                return `Turned on accepting chat at: ${new Date(value)}\n`;
            case 'acceptingChatOffTime':
                return `Turned off accepting chat at: ${new Date(value)}\n`;
            case 'browserInfo':
                return `Browser name: ${value.name} and OS: ${value.os}\n`;
            case 'transferChat':
                return `Transfer Chat To: ${value.toDoctorName} transfer From : ${value.fromDoctorName} Patient Name : ${value.patientName} at ${new Date(value.timestamp)} ` 
            default:
                return null;
        }
    }

    render() {
        const { startDate, endDate } = this.state;

        return (
            <Aux>
          
                <div className={classes.main}>
                   
                <div className={classes.header}>Activity</div>

<div className={classes.controls}>
  {/* ── Start date ───────────────────────────────────────── */}
  <div className={classes.field}>
    <label htmlFor="start" className={classes.dateLabel}>
      Start date
    </label>
    <input
      id="start"
      type="date"
      value={startDate}
      onChange={this.handleChange("startDate")}
      className={classes.dateInput}
    />
  </div>

  {/* ── End date ─────────────────────────────────────────── */}
  <div className={classes.field}>
    <label htmlFor="end" className={classes.dateLabel}>
      End date
    </label>
    <input
      id="end"
      type="date"
      value={endDate}
      onChange={this.handleChange("endDate")}
      className={classes.dateInput}
    />
  </div>

  <button className={classes.searchButton} onClick={this.handleSearch}>
    Search
  </button>
</div>

                    {this.props.actvities.map(activity => {
                        return (
                            <div key={activity.key}>
                                <div className={classes.main_body}>Date: {activity.key}</div>
                                {activity.data.map((home, index) =>
                                    <div key={index}>
                                        <div className={classes.heading}>Doctor Name: {home.doctorName}</div>
                                        {home.childData.map((log, index) =>
                                            <div key={index}>
                                                {Object.entries(log).map(([key, val], index) =>
                                                    <div key={index}
                                                         className={classes.sub_content}> {this.checkString(key, val)} </div>
                                                )}
                                            </div>
                                        )}
                                    </div>
                                )}
                            </div>
                        )
                    })}
                </div>
            </Aux>
        )
    }
}

const mapStateToProps = ({activitiesReducer}) => {
    const {actvities, loading, error} = activitiesReducer;
    return {actvities, loading, error};
}

const mapDispatchToProps = dispatch => ({
    fetchAllActivites: (start, end) => dispatch(fetchAllActivites(start, end)),
  });
  
  export default connect(mapStateToProps, mapDispatchToProps)(Activities);

// export default connect(mapStateToProps, {fetchAllActivites})(Activities);
